import { IAddEditParentAdminFormData } from 'src/components/enterprise/Parents/Admin/types';
import { SsoIdentifierTypes } from 'src/types/Corp';

export function getSsoUniqueIdentifier(
  formData: IAddEditParentAdminFormData
): string | null {
  switch (formData.corpSsoIdentifierType) {
    case SsoIdentifierTypes.EMAIL:
      return formData.email;
    case SsoIdentifierTypes.OTHER:
      return formData.ssoUniqueIdentifier;
    case SsoIdentifierTypes.INTERNAL_ID:
      return formData.internalId;
    default:
      return null;
  }
}
